export const ManufaturedInventorySuccess = 'MANUFACTUREDINVENTORY_LIST_SUCCESS';
export const UnregisteredInventoryListSuccess =
  'UNREGISTEREDINVENTORY_LIST_SUCCESS';
export const RegisteredInventoryListSuccess =
  'REGISTEREDINVENTORY_LIST_SUCCESS';
export const InventoryFilterSuccess = 'INVENTORY_FILTER_LIST_SUCCESS';

export function setManufaturedInventoryListAction(data) {
  return {
    type: ManufaturedInventorySuccess,
    payload: data,
  };
}

export function setUnregisteredInventoryListAction(data) {
  return {
    type: UnregisteredInventoryListSuccess,
    payload: data,
  };
}

export function setRegisteredInventoryListAction(data) {
  return {
    type: RegisteredInventoryListSuccess,
    payload: data,
  };
}

export function setInventoryFilterAction(data) {
  return {
    type: InventoryFilterSuccess,
    payload: data,
  };
}
